module.exports = __webpack_public_path__ + "static/img/guoyao-logo2.747d7de8.png";